/**
 * LegalPerson: company name is `companyName` (legacy: `name`).
 * Address fields are top-level on LegalPerson (legacy: nested `headquarters`).
 */

export function legalPersonAddressFields(lp: any): {
    street: string;
    streetNumber: string;
    postalCode: string;
    city: string;
    country: string;
} {
    const h = lp?.headquarters;
    return {
        street: lp?.street ?? h?.street ?? "",
        streetNumber: lp?.streetNumber ?? h?.streetNumber ?? "",
        postalCode: lp?.postalCode ?? h?.postalCode ?? "",
        city: lp?.city ?? h?.city ?? "",
        country: lp?.country ?? h?.country ?? "",
    };
}

/**
 * Human-readable label: company name when present; otherwise address, email, or id so UI never shows a blank row.
 */
export function legalPersonCompanyName(lp: { companyName?: string; name?: string; email?: string; _id?: string } | null | undefined): string {
    if (!lp) {
        return "";
    }
    const direct = (lp.companyName ?? lp.name ?? "").trim();
    if (direct.length > 0) {
        return direct;
    }
    const a = legalPersonAddressFields(lp);
    const streetLine = `${a.street} ${a.streetNumber}`.trim();
    const cityLine = `${a.postalCode} ${a.city}`.trim();
    const fromAddress = [streetLine, cityLine].filter((x) => x.length > 0).join(", ");
    if (fromAddress.length > 0) {
        return fromAddress;
    }
    const em = lp.email != null ? String(lp.email).trim() : "";
    if (em.length > 0) {
        return em;
    }
    const id = lp._id != null ? String(lp._id) : "";
    if (id.length > 0) {
        return id.length > 14 ? `LegalPerson (…${id.slice(-12)})` : `LegalPerson (${id})`;
    }
    return "";
}

export function legalPersonStreetLine(lp: any): string {
    const a = legalPersonAddressFields(lp);
    const line = `${a.street} ${a.streetNumber}`.trim();
    return line;
}

export function legalPersonCityLine(lp: any): string {
    const a = legalPersonAddressFields(lp);
    const line = `${a.postalCode} ${a.city}`.trim();
    return line;
}

export function legalPersonPostalLine(lp: any): string {
    const a = legalPersonAddressFields(lp);
    const parts = [legalPersonStreetLine(lp), `${a.postalCode} ${a.city}`.trim()];
    if (a.country) {
        parts.push(a.country);
    }
    return parts.filter(Boolean).join(", ");
}
